import React from "react";
import { Box, Heading, Button, HStack, VStack, Stat, StatLabel, StatNumber, StatHelpText, Select, Text, SimpleGrid, Input, Checkbox, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter, Tag, TagLabel, TagCloseButton, Wrap, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, IconButton, Avatar, AvatarGroup, Tabs, TabList, TabPanels, TabPanel, Tab, Container, useColorModeValue, Badge, Divider, Spacer, Icon, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from "@chakra-ui/react";
import { listForms, listTechnicians } from "../../../utils/formsApi";
import { ResponsiveContainer, ComposedChart, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell, LineChart, Line, AreaChart, Area, CartesianGrid } from "recharts";
import { useNavigate } from "react-router-dom";
import ModernTable, { TABLE_ACTIONS } from "../../../components/tables/ModernTable";
import { FiActivity, FiBarChart2, FiCheckCircle, FiCreditCard, FiDollarSign, FiEye, FiFilter, FiList, FiTool, FiTrendingUp, FiUsers, FiXCircle } from "react-icons/fi";
import { FaTurkishLiraSign } from "react-icons/fa6";

export default function FormsStats() {
  const navigate = useNavigate();
  const [rows, setRows] = React.useState([]);
  const [monthCountData, setMonthCountData] = React.useState([]);
  const [weekCountData, setWeekCountData] = React.useState([]);
  const [weekdayCountData, setWeekdayCountData] = React.useState([]);
  const [hourBucketData, setHourBucketData] = React.useState([]);
  const [monthSumData, setMonthSumData] = React.useState([]);
  const [paymentData, setPaymentData] = React.useState([]);
  const [technicianData, setTechnicianData] = React.useState([]);
  const [customerData, setCustomerData] = React.useState([]);
  const [faultyDeviceData, setFaultyDeviceData] = React.useState([]);
  const [opVisitHistogram, setOpVisitHistogram] = React.useState([]);
  const [opVisitTopJobs, setOpVisitTopJobs] = React.useState([]);
  const [deliveryMontajJobs, setDeliveryMontajJobs] = React.useState([]);
  const [deliveryDevreyeJobs, setDeliveryDevreyeJobs] = React.useState([]);
  const [deliveryJobOpen, setDeliveryJobOpen] = React.useState(false);
  const [selectedDeliveryJob, setSelectedDeliveryJob] = React.useState(null);

  const getSurveyAvg = (row) => {
    const s = row?.survey || {};
    const vals = [s.q1, s.q2, s.q3, s.q4].filter((v) => typeof v === "number" && v > 0);
    if (!vals.length) return null;
    return vals.reduce((a, b) => a + b, 0) / vals.length;
  };
  const [opDatesOpen, setOpDatesOpen] = React.useState(false);
  const [selectedOpJob, setSelectedOpJob] = React.useState(null);
  const [period, setPeriod] = React.useState("12");
  const [techs, setTechs] = React.useState([]);
  const [techFilter, setTechFilter] = React.useState("all");
  const [deviceData, setDeviceData] = React.useState([]);
  const [monthlyPaymentRate, setMonthlyPaymentRate] = React.useState([]);
  const [monthlyFollowRate, setMonthlyFollowRate] = React.useState([]);
  const [opTypesData, setOpTypesData] = React.useState([]);
  const [feeHistogram, setFeeHistogram] = React.useState([]);
  const [avgFee, setAvgFee] = React.useState(0);
  const [medianFee, setMedianFee] = React.useState(0);
  const [overallSurveyAvg, setOverallSurveyAvg] = React.useState(0);
  const [techSurveyAvgData, setTechSurveyAvgData] = React.useState([]);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [isListOpen, setIsListOpen] = React.useState(false);
  const [monthSel, setMonthSel] = React.useState("all");
  const [yearSel, setYearSel] = React.useState("all");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [deliveryStartDate, setDeliveryStartDate] = React.useState("");
  const [deliveryEndDate, setDeliveryEndDate] = React.useState("");
  const [startTime, setStartTime] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const [monthlyAvgCount, setMonthlyAvgCount] = React.useState(0);
  const [monthlyFollowCountData, setMonthlyFollowCountData] = React.useState([]);
  const [unpaidReasons, setUnpaidReasons] = React.useState([]);
  const [monthlyQSeries, setMonthlyQSeries] = React.useState([]);
  const [monthlySurveySummary, setMonthlySurveySummary] = React.useState([]);
  const [monthlySurveyStatusByMonth, setMonthlySurveyStatusByMonth] = React.useState([]);
  const [surveyDist, setSurveyDist] = React.useState([]);
  const [surveyStatusDist, setSurveyStatusDist] = React.useState([]);
  const [payFilter, setPayFilter] = React.useState("all"); // all, paid, unpaid
  const [followFilter, setFollowFilter] = React.useState("all"); // all, yes, no
  const [deliveredFilter, setDeliveredFilter] = React.useState("all"); // all, yes, no
  const [deviceFilter, setDeviceFilter] = React.useState("all");
  const [projectQuery, setProjectQuery] = React.useState("");
  const [unpaidReasonFilter, setUnpaidReasonFilter] = React.useState("all");
  const [opTypeFilter, setOpTypeFilter] = React.useState("all");
  const [minFee, setMinFee] = React.useState("");
  const [maxFee, setMaxFee] = React.useState("");
  const [includeNoFee, setIncludeNoFee] = React.useState(true);
  const [filtersOpen, setFiltersOpen] = React.useState(false);
  const [monthlyAvgDuration, setMonthlyAvgDuration] = React.useState([]);
  const [selectedMonthTechHours, setSelectedMonthTechHours] = React.useState([]);
  const [monthlyTotalWorkHours, setMonthlyTotalWorkHours] = React.useState([]);
  const [techQualityData, setTechQualityData] = React.useState([]);
  const [lowSurveyForms, setLowSurveyForms] = React.useState([]);

  const toMonthKey = (d) => {
    if (!d) return null;
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return null;
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
  };

  const compute = React.useCallback((all) => {
    const now = new Date();
    const monthsBack = period === "all" ? null : (Number(period) || 12);
    const cutoff = monthsBack ? new Date(now.getFullYear(), now.getMonth() - monthsBack + 1, 1) : null;
    const toWeekKey = (dt) => {
      try {
        if (!(dt instanceof Date) || isNaN(dt.getTime())) return null;
        const d = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()));
        const dayNum = (d.getUTCDay() + 6) % 7;
        d.setUTCDate(d.getUTCDate() - dayNum + 3);
        const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
        const firstDayNum = (firstThursday.getUTCDay() + 6) % 7;
        firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNum + 3);
        const week = 1 + Math.round((d.getTime() - firstThursday.getTime()) / 604800000);
        const year = d.getUTCFullYear();
        return `${year}-W${String(week).padStart(2, "0")}`;
      } catch (_) { return null; }
    };
    const weekdayLabel = (dt) => {
      const map = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
      if (!(dt instanceof Date) || isNaN(dt.getTime())) return null;
      return map[dt.getDay()] || null;
    };
    const hourBucketLabel = (timeStr) => {
      if (typeof timeStr !== "string") return null;
      const m = String(timeStr).match(/^(\d{1,2}):(\d{2})/);
      if (!m) return null;
      const h = Number(m[1]);
      if (isNaN(h) || h < 0 || h > 23) return null;
      if (h < 6) return "00-06";
      if (h < 9) return "06-09";
      if (h < 12) return "09-12";
      if (h < 15) return "12-15";
      if (h < 18) return "15-18";
      return "18-24";
    };
    const normalizeKey = (s) => String(s || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const buildJobKey = (f) => {
      const project = normalizeKey(f.project_name);
      const customer = normalizeKey(f.customer_name);
      const phone = normalizeKey(String(f.customer_phone || "").replace(/\D/g, "").slice(-10));
      const addr = normalizeKey(f.customer_address);
      return [project || "", customer || "", phone || "", addr || ""].join(" | ");
    };
    const jobLabel = (f) => {
      const c = String(f.customer_name || "").trim() || "Bilinmiyor";
      const p = String(f.project_name || "").trim();
      const a = String(f.customer_address || "").trim();
      const right = p || a;
      return right ? `${c} • ${right}` : c;
    };

    const filterFn = (f, { ignorePeriod } = { ignorePeriod: false }) => {
      // Prioritize service_date for stats
      const d = f.service_date || f.created_at;
      const dt = new Date(d);
      if (isNaN(dt.getTime())) return false;

      // Date and Time Range filters
      if (startDate && d < startDate) return false;
      if (endDate && d > endDate) return false;
      if (deliveryStartDate || deliveryEndDate) {
        if (!f.delivered_working) return false;
        const dd = f.service_date || f.created_at;
        if (!dd) return false;
        if (deliveryStartDate && dd < deliveryStartDate) return false;
        if (deliveryEndDate && dd > deliveryEndDate) return false;
      }

      if (startTime || endTime) {
        const jobStart = f.service_start_time || "00:00";
        const jobEnd = f.service_end_time || jobStart;
        const fStart = startTime || "00:00";
        const fEnd = endTime || "23:59";

        // Overlap logic: Job must start before filter end AND end after filter start
        const isVisible = jobStart <= fEnd && jobEnd >= fStart;
        if (!isVisible) return false;
      }

      if (!ignorePeriod && cutoff && !(dt >= cutoff)) return false;
      if (yearSel !== "all" && String(dt.getFullYear()) !== String(yearSel)) return false;
      if (monthSel !== "all" && String(dt.getMonth() + 1).padStart(2, "0") !== String(monthSel)) return false;
      if (projectQuery && !(String(f.project_name || "").toLowerCase().includes(projectQuery.toLowerCase()))) return false;
      if (deviceFilter !== "all" && String(f.device_type || "Bilinmiyor") !== deviceFilter) return false;
      const feeNum = Number(f.service_fee);
      const hasFee = !isNaN(feeNum) && feeNum > 0;
      if (!includeNoFee && !hasFee) return false;
      if (minFee && !(hasFee && feeNum >= Number(minFee))) return false;
      if (maxFee && !(hasFee && feeNum <= Number(maxFee))) return false;
      const pr = f.payment_received;
      const note = String(f.payment_note || "").toLowerCase();
      const paidHeuristic = (pr === true) || (pr == null && hasFee) || (note.includes("alındı") || note.includes("ödeme") || note.includes("odeme"));
      if (payFilter === "paid" && !paidHeuristic) return false;
      if (payFilter === "unpaid" && paidHeuristic) return false;
      if (followFilter !== "all") {
        const v = !!f.follow_up_needed;
        if (followFilter === "yes" && !v) return false;
        if (followFilter === "no" && v) return false;
      }
      if (deliveredFilter !== "all") {
        const v = !!f.delivered_working;
        if (deliveredFilter === "yes" && !v) return false;
        if (deliveredFilter === "no" && v) return false;
      }
      if (unpaidReasonFilter !== "all") {
        if (paidHeuristic) return false;
        const n = note.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const tag = (n.includes("tanidik") || n.includes("es") || n.includes("dost")) ? "Tanıdık"
          : (n.includes("garanti") || n.includes("kapsam") || n.includes("teminat")) ? "Garanti kapsamında"
            : (n.includes("teknik") || n.includes("ariza")) ? "Teknik sorun"
              : "Diğer";
        if (tag !== unpaidReasonFilter) return false;
      }
      if (opTypeFilter !== "all") {
        const ops = f.operation_types || {};
        if (!ops[opTypeFilter]) return false;
      }
      return true;
    };
    const filtered = all.filter((f) => filterFn(f, { ignorePeriod: false }));
    const filteredAllMonths = all.filter((f) => filterFn(f, { ignorePeriod: true }));
    const monthMap = new Map();
    const weekMap = new Map();
    const weekdayMap = new Map([["Pazartesi", 0], ["Salı", 0], ["Çarşamba", 0], ["Perşembe", 0], ["Cuma", 0], ["Cumartesi", 0], ["Pazar", 0]]);
    const hourMap = new Map([["00-06", 0], ["06-09", 0], ["09-12", 0], ["12-15", 0], ["15-18", 0], ["18-24", 0]]);
    const sumMap = new Map();
    let paid = 0, unpaid = 0, sumFees = 0;
    const techMap = new Map();
    const deviceMap = new Map();
    const customerMap = new Map();
    const faultyDeviceMap = new Map();
    const rateMap = new Map(); // month => {paid,total,follow}
    const opMap = new Map(); // opType => count
    const fees = [];
    const techSurveyMap = new Map(); // name => {sum, count}
    const monthlyQ = new Map(); // month => {q1:[],q2:[],q3:[],q4:[]}
    const surveyFormAverages = [];
    const reasonMap = new Map(); // unpaid reason => count
    const monthlyDurAgg = new Map(); // month => {sumMin, count}
    const monthTechHours = new Map(); // month => Map(name => sumMin)
    const techQualityMap = new Map(); // name => {forms, paid, unpaid, follow, delivered, surveySum, surveyCount, lowSurvey, sumMin, minCount}
    const lowSurveyList = [];
    const opVisitByJob = new Map(); // jobKey => {label, visits, latestDate, dates:Set, items:[]}
    const deliveryByOpJob = new Map(); // op|jobKey => {opKey,label,visits,latestDate,dates:Set,items:[]}
    const parseMinutes = (f) => {
      try {
        const dstr = f.service_date || f.created_at;
        const sstr = f.service_start_time;
        const estr = f.service_end_time;
        const bd = new Date(dstr);
        if (!bd || isNaN(bd.getTime())) return null;
        const rx = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;
        if (typeof sstr !== "string" || typeof estr !== "string") return null;
        const sm = sstr.match(rx), em = estr.match(rx);
        if (!sm || !em) return null;
        const s = new Date(bd.getTime());
        s.setHours(Number(sm[1] || 0), Number(sm[2] || 0), Number(sm[3] || 0), 0);
        const e = new Date(bd.getTime());
        e.setHours(Number(em[1] || 0), Number(em[2] || 0), Number(em[3] || 0), 0);
        const diff = e.getTime() - s.getTime();
        if (isNaN(diff) || diff <= 0) return null;
        const minutes = Math.round(diff / 60000);
        if (minutes > 12 * 60) return null;
        return minutes;
      } catch (_) { return null; }
    };
    filtered.forEach(f => {
      const rawDate = f.service_date || f.created_at;
      const dtx = new Date(rawDate);
      if (!isNaN(dtx.getTime())) {
        const wk = toWeekKey(dtx);
        if (wk) weekMap.set(wk, (weekMap.get(wk) || 0) + 1);
        const wd = weekdayLabel(dtx);
        if (wd) weekdayMap.set(wd, (weekdayMap.get(wd) || 0) + 1);
      }
      const hb = hourBucketLabel(f.service_start_time);
      if (hb) hourMap.set(hb, (hourMap.get(hb) || 0) + 1);

      const key = toMonthKey(f.service_date || f.created_at) || "Unknown";
      monthMap.set(key, (monthMap.get(key) || 0) + 1);
      const feeNum = Number(f.service_fee);
      const hasFee = !isNaN(feeNum) && feeNum > 0;
      if (!isNaN(feeNum)) {
        sumMap.set(key, (sumMap.get(key) || 0) + feeNum);
        fees.push(feeNum);
      }
      const pr = f.payment_received;
      const note = String(f.payment_note || "").toLowerCase();
      const paidHeuristic = (pr === true) || (pr == null && (!isNaN(feeNum) && feeNum > 0)) || (note.includes("alındı") || note.includes("ödeme") || note.includes("odeme"));
      if (paidHeuristic) paid += 1; else unpaid += 1;
      if (!paidHeuristic) {
        const n = note.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const r = (n.includes("tanidik") || n.includes("es") || n.includes("dost")) ? "Tanıdık"
          : (n.includes("garanti") || n.includes("kapsam") || n.includes("teminat")) ? "Garanti kapsamında"
            : (n.includes("teknik") || n.includes("ariza")) ? "Teknik sorun"
              : "Diğer";
        reasonMap.set(r, (reasonMap.get(r) || 0) + 1);
      }
      const techNames = [];
      const mainTech = ((f.technician && f.technician.name) || null);
      if (mainTech) techNames.push(mainTech);
      if (Array.isArray(f.team) && f.team.length) {
        for (const t of f.team) {
          if (t && t.name) techNames.push(t.name);
        }
      }
      if (!techNames.length) techNames.push("Bilinmiyor");
      techNames.forEach(name => techMap.set(name, (techMap.get(name) || 0) + 1));
      if (!isNaN(feeNum)) sumFees += feeNum;
      const dev = (f.device_type || "Bilinmiyor");
      deviceMap.set(dev, (deviceMap.get(dev) || 0) + 1);
      const customer = String(f.customer_name || "").trim() || "Bilinmiyor";
      customerMap.set(customer, (customerMap.get(customer) || 0) + 1);
      const devSerial = String(f.device_serial || "").trim();
      const devKey = devSerial ? `${dev} • ${devSerial}` : dev;
      faultyDeviceMap.set(devKey, (faultyDeviceMap.get(devKey) || 0) + 1);
      const r = rateMap.get(key) || { paid: 0, total: 0, follow: 0 };
      r.total += 1;
      if (paidHeuristic) r.paid += 1;
      if (f.follow_up_needed) r.follow += 1;
      rateMap.set(key, r);
      const ops = f.operation_types || {};
      Object.keys(ops).forEach(k => {
        if (ops[k]) opMap.set(k, (opMap.get(k) || 0) + 1);
      });
      if (ops.SISTEM_DEVREYE_ALMA || ops.DIGER) {
        const jk = buildJobKey(f);
        const rec = opVisitByJob.get(jk) || { label: jobLabel(f), visits: 0, latestDate: "", dates: new Set(), items: [] };
        rec.visits += 1;
        const d2 = String(f.service_date || f.created_at || "").slice(0, 10);
        if (d2) {
          rec.dates.add(d2);
          if (!rec.latestDate || d2 > rec.latestDate) rec.latestDate = d2;
        }
        rec.items.push({
          id: f.id,
          date: d2 || "",
          start: String(f.service_start_time || "").slice(0, 5),
          end: String(f.service_end_time || "").slice(0, 5),
          serial: String(f.serial_number || "").trim(),
          op: ops.SISTEM_DEVREYE_ALMA ? "SİSTEM DEVREYE ALMA" : "DİĞER",
        });
        opVisitByJob.set(jk, rec);
      }
      const s = f.survey || {};
      const sv = [s.q1, s.q2, s.q3, s.q4].filter(v => typeof v === "number" && v > 0);
      let favg = null;
      if (sv.length) {
        favg = sv.reduce((a, b) => a + b, 0) / sv.length;
        surveyFormAverages.push(favg);
        techNames.forEach(name => {
          const rec = techSurveyMap.get(name) || { sum: 0, count: 0 };
          rec.sum += favg;
          rec.count += 1;
          techSurveyMap.set(name, rec);
        });
        const mq = monthlyQ.get(key) || { q1: [], q2: [], q3: [], q4: [] };
        if (typeof s.q1 === "number" && s.q1 > 0) mq.q1.push(s.q1);
        if (typeof s.q2 === "number" && s.q2 > 0) mq.q2.push(s.q2);
        if (typeof s.q3 === "number" && s.q3 > 0) mq.q3.push(s.q3);
        if (typeof s.q4 === "number" && s.q4 > 0) mq.q4.push(s.q4);
        monthlyQ.set(key, mq);
      }
      const minutes = parseMinutes(f);
      if (minutes != null) {
        const agg = monthlyDurAgg.get(key) || { sumMin: 0, count: 0 };
        agg.sumMin += minutes; agg.count += 1;
        monthlyDurAgg.set(key, agg);
        const mt = monthTechHours.get(key) || new Map();
        techNames.forEach(name => mt.set(name, (mt.get(name) || 0) + minutes));
        monthTechHours.set(key, mt);
      }

      const delivered = !!f.delivered_working;
      const follow = !!f.follow_up_needed;
      const dateStr = String(f.service_date || f.created_at || "").slice(0, 10);
      const techLabel = techNames.filter(Boolean).join(", ");
      const customerName = String(f.customer_name || "").trim() || "Bilinmiyor";
      const projectName = String(f.project_name || "").trim() || "";
      const serialNumber = String(f.serial_number || "").trim();

      techNames.forEach((name) => {
        const rec = techQualityMap.get(name) || {
          forms: 0,
          paid: 0,
          unpaid: 0,
          feeSum: 0,
          feeCount: 0,
          follow: 0,
          delivered: 0,
          surveySum: 0,
          surveyCount: 0,
          lowSurvey: 0,
          sumMin: 0,
          minCount: 0,
        };
        rec.forms += 1;
        if (paidHeuristic) rec.paid += 1; else rec.unpaid += 1;
        if (hasFee) {
          rec.feeSum += feeNum;
          rec.feeCount += 1;
        }
        if (follow) rec.follow += 1;
        if (delivered) rec.delivered += 1;
        if (typeof favg === "number" && !isNaN(favg)) {
          rec.surveySum += favg;
          rec.surveyCount += 1;
          if (favg < 3) rec.lowSurvey += 1;
        }
        if (minutes != null) {
          rec.sumMin += minutes;
          rec.minCount += 1;
        }
        techQualityMap.set(name, rec);
      });

      if (typeof favg === "number" && !isNaN(favg) && favg < 3) {
        lowSurveyList.push({
          id: f.id,
          serial_number: serialNumber,
          customer_name: customerName,
          project_name: projectName,
          service_date: dateStr,
          tech: techLabel,
          avg: Math.round(favg * 10) / 10,
        });
      }

      if (f.delivered_working) {
        const deliveryDate = f.service_date || f.created_at;
        const dd = String(deliveryDate || "");
        const deliveryInRange =
          (!deliveryStartDate || dd >= deliveryStartDate) &&
          (!deliveryEndDate || dd <= deliveryEndDate);
        if (deliveryDate && deliveryInRange) {
          const jobKey = buildJobKey(f);
          const label = jobLabel(f);
          const pushDelivery = (opKey) => {
            const mapKey = `${opKey}||${jobKey}`;
            const rec = deliveryByOpJob.get(mapKey) || { opKey, label, visits: 0, latestDate: null, dates: new Set(), items: [] };
            rec.visits += 1;
            rec.dates.add(deliveryDate);
            rec.items.push({
              id: f.id,
              date: deliveryDate,
              serial: f.serial_number || f.serial || "",
              tech: (f.technician && f.technician.name) || "",
              project: f.project_name || "",
              customer: f.customer_name || "",
            });
            if (!rec.latestDate || String(deliveryDate) > String(rec.latestDate)) rec.latestDate = deliveryDate;
            deliveryByOpJob.set(mapKey, rec);
          };
          if (ops.EK_URUN_MONTAJI) pushDelivery("EK_URUN_MONTAJI");
          if (ops.SISTEM_DEVREYE_ALMA) pushDelivery("SISTEM_DEVREYE_ALMA");
        }
      }
    });
    const monthKeys = Array.from(monthMap.keys()).sort();
    const weekKeys = Array.from(weekMap.keys()).sort();
    setWeekCountData(weekKeys.slice(Math.max(0, weekKeys.length - 16)).map((k) => ({ week: k, count: weekMap.get(k) || 0 })));
    setWeekdayCountData(["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"].map((name) => ({ name, count: weekdayMap.get(name) || 0 })));
    setHourBucketData(["00-06", "06-09", "09-12", "12-15", "15-18", "18-24"].map((name) => ({ name, count: hourMap.get(name) || 0 })));
    setMonthCountData(monthKeys.map((k, idx) => {
      const count = monthMap.get(k) || 0;
      const prevKey = idx > 0 ? monthKeys[idx - 1] : null;
      const prevCount = prevKey ? (monthMap.get(prevKey) || 0) : null;
      const changePct = (prevCount && prevCount > 0)
        ? Math.round(((count - prevCount) / prevCount) * 1000) / 10
        : null;
      return { month: k, count, changePct };
    }));
    setMonthSumData(monthKeys.map(k => ({ month: k, total: sumMap.get(k) || 0 })));
    setPaymentData([
      { name: "Alındı", value: paid },
      { name: "Alınmadı", value: unpaid },
    ]);
    setTechnicianData(Array.from(techMap.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count));
    setCustomerData(Array.from(customerMap.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count));
    setFaultyDeviceData(Array.from(faultyDeviceMap.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count));
    setDeviceData(Array.from(deviceMap.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count));
    setMonthlyPaymentRate(monthKeys.map(k => {
      const r = rateMap.get(k) || { paid: 0, total: 0, follow: 0 };
      return { month: k, rate: r.total ? Math.round((r.paid / r.total) * 100) : 0 };
    }));
    setMonthlyFollowRate(monthKeys.map(k => {
      const r = rateMap.get(k) || { paid: 0, total: 0, follow: 0 };
      return { month: k, rate: r.total ? Math.round((r.follow / r.total) * 100) : 0 };
    }));
    setMonthlyFollowCountData(monthKeys.map(k => {
      const r = rateMap.get(k) || { paid: 0, total: 0, follow: 0 };
      return { month: k, count: r.follow || 0 };
    }));
    setMonthlyAvgCount(monthKeys.length ? (filtered.length / monthKeys.length) : 0);
    setOpTypesData(Array.from(opMap.entries()).map(([name, count]) => ({ key: name, name: name.replace(/_/g, " "), count })).sort((a, b) => b.count - a.count));
    setUnpaidReasons(Array.from(reasonMap.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count));
    // Per-question monthly averages
    const qSeries = monthKeys.map(k => {
      const mq = monthlyQ.get(k) || { q1: [], q2: [], q3: [], q4: [] };
      const avg = arr => arr.length ? (arr.reduce((a, b) => a + b, 0) / arr.length) : 0;
      return { month: k, q1: avg(mq.q1), q2: avg(mq.q2), q3: avg(mq.q3), q4: avg(mq.q4) };
    });
    setMonthlyQSeries(qSeries);

    const monthlySurveyAgg = new Map(); // month => {sum,count, success, unreachable, refused, noPhone}
    filtered.forEach((f) => {
      const month = toMonthKey(f.service_date || f.created_at) || "Unknown";
      const s = f.survey || {};
      const vals = [s.q1, s.q2, s.q3, s.q4].filter((v) => typeof v === "number" && v > 0);
      const st = String(s.status || "").toLowerCase();
      const rec = monthlySurveyAgg.get(month) || { sum: 0, count: 0, success: 0, unreachable: 0, refused: 0, noPhone: 0 };

      if (vals.length) {
        const favg = vals.reduce((a, b) => a + b, 0) / vals.length;
        rec.sum += favg;
        rec.count += 1;
        rec.success += 1;
      } else if (st === "tamamlandi" || st === "basarili") {
        rec.success += 1;
      } else if (st === "ulasilamadi") {
        rec.unreachable += 1;
      } else if (st === "istemedi") {
        rec.refused += 1;
      } else if (st === "numara_yok") {
        rec.noPhone += 1;
      }

      monthlySurveyAgg.set(month, rec);
    });
    setMonthlySurveySummary(monthKeys.map((month) => {
      const rec = monthlySurveyAgg.get(month) || { sum: 0, count: 0, success: 0, unreachable: 0, refused: 0, noPhone: 0 };
      return {
        month,
        avg: rec.count ? (Math.round((rec.sum / rec.count) * 10) / 10) : 0,
        count: rec.count,
      };
    }));
    setMonthlySurveyStatusByMonth(monthKeys.map((month) => {
      const rec = monthlySurveyAgg.get(month) || { sum: 0, count: 0, success: 0, unreachable: 0, refused: 0, noPhone: 0 };
      return {
        month,
        success: rec.success || 0,
        unreachable: rec.unreachable || 0,
        refused: rec.refused || 0,
        noPhone: rec.noPhone || 0,
      };
    }));
    // Monthly average working duration (minutes)
    setMonthlyAvgDuration(monthKeys.map(k => {
      const agg = monthlyDurAgg.get(k) || { sumMin: 0, count: 0 };
      return { month: k, minutes: agg.count ? Math.round(agg.sumMin / agg.count) : 0 };
    }));

    const buildMonthlyTotalHours = (list) => {
      const m = new Map();
      list.forEach((f) => {
        const minutes = parseMinutes(f);
        if (minutes == null) return;
        const key = toMonthKey(f.service_date || f.created_at) || "Unknown";
        m.set(key, (m.get(key) || 0) + minutes);
      });
      return m;
    };
    const totalAll = buildMonthlyTotalHours(filteredAllMonths);
    const totalSelected = buildMonthlyTotalHours(filtered);
    const totalKeys = Array.from(new Set([...Array.from(totalAll.keys()), ...Array.from(totalSelected.keys())])).sort();
    setMonthlyTotalWorkHours(totalKeys.map((k) => ({
      month: k,
      allHours: Math.round(((totalAll.get(k) || 0) / 60) * 10) / 10,
      selectedHours: totalSelected.has(k) ? (Math.round(((totalSelected.get(k) || 0) / 60) * 10) / 10) : null,
    })));
    // Selected month technician hours
    const latestMonth = monthKeys[monthKeys.length - 1] || null;
    const chosenMonth = (monthSel !== "all" && yearSel !== "all") ? `${yearSel}-${monthSel}` : latestMonth;
    const mt = (chosenMonth ? monthTechHours.get(chosenMonth) : null) || new Map();
    const techHoursArr = Array.from(mt.entries()).map(([name, minutes]) => ({ name, hours: Math.round((minutes || 0) / 60) }));
    setSelectedMonthTechHours(techHoursArr.sort((a, b) => b.hours - a.hours).slice(0, 12));
    // Survey distribution (overall avg rounded 1..5)
    const dist = new Map([["1", 0], ["2", 0], ["3", 0], ["4", 0], ["5", 0]]);
    filtered.forEach(f => {
      const s = f.survey || {};
      const vals = [s.q1, s.q2, s.q3, s.q4].filter(v => typeof v === "number" && v > 0);
      if (!vals.length) return;
      const favg = vals.reduce((a, b) => a + b, 0) / vals.length;
      const bucket = String(Math.max(1, Math.min(5, Math.round(favg))));
      dist.set(bucket, (dist.get(bucket) || 0) + 1);
    });
    setSurveyDist(Array.from(dist.entries()).map(([rating, count]) => ({ rating, count })));
    // Survey status distribution
    const statusMap = new Map([["Anket başarılı", 0], ["Ankete ulaşılamadı", 0], ["Cevaplamak istemedi", 0], ["Numarası yok", 0]]);
    filtered.forEach(f => {
      const s = f.survey || {};
      const vals = [s.q1, s.q2, s.q3, s.q4].filter(v => typeof v === "number" && v > 0);
      const st = String(s.status || "").toLowerCase();

      let key = null;
      if (vals.length) key = "Anket başarılı";
      else if (st === "tamamlandi" || st === "basarili") key = "Anket başarılı";
      else if (st === "ulasilamadi") key = "Ankete ulaşılamadı";
      else if (st === "istemedi") key = "Cevaplamak istemedi";
      else if (st === "numara_yok") key = "Numarası yok";

      if (key) statusMap.set(key, (statusMap.get(key) || 0) + 1);
    });
    setSurveyStatusDist(Array.from(statusMap.entries()).map(([name, count]) => ({ name, count })));
    // Fee histogram (bin size 1000 TRY)
    const binSize = 1000;
    const bins = new Map();
    fees.forEach(v => {
      const bin = `${Math.floor(v / binSize) * binSize}-${Math.floor(v / binSize) * binSize + binSize - 1}`;
      bins.set(bin, (bins.get(bin) || 0) + 1);
    });
    setFeeHistogram(Array.from(bins.entries()).map(([range, count]) => ({ range, count })).sort((a, b) => {
      const pa = Number(a.range.split("-")[0]), pb = Number(b.range.split("-")[0]); return pa - pb;
    }));
    const avg = fees.length ? (fees.reduce((a, b) => a + b, 0) / fees.length) : 0;
    const med = fees.length ? (() => { const s = [...fees].sort((a, b) => a - b); const mid = Math.floor(s.length / 2); return s.length % 2 ? s[mid] : (s[mid - 1] + s[mid]) / 2; })() : 0;
    setAvgFee(avg);
    setMedianFee(med);
    const overall = surveyFormAverages.length ? (surveyFormAverages.reduce((a, b) => a + b, 0) / surveyFormAverages.length) : 0;
    setOverallSurveyAvg(overall);
    setTechSurveyAvgData(Array.from(techSurveyMap.entries()).map(([name, rec]) => ({ name, avg: rec.count ? (rec.sum / rec.count) : 0 })).sort((a, b) => b.avg - a.avg));
    setFilteredRows(filtered);
    const visitHistogramMap = new Map();
    for (const rec of opVisitByJob.values()) {
      const v = rec.visits || 0;
      if (v <= 0) continue;
      visitHistogramMap.set(v, (visitHistogramMap.get(v) || 0) + 1);
    }
    const visitKeys = Array.from(visitHistogramMap.keys()).sort((a, b) => a - b);
    setOpVisitHistogram(visitKeys.map((v) => ({ visits: String(v), jobs: visitHistogramMap.get(v) || 0 })));
    setOpVisitTopJobs(
      Array.from(opVisitByJob.values())
        .sort((a, b) => (b.visits || 0) - (a.visits || 0))
        .slice(0, 12)
        .map((x) => {
          const dateArr = Array.from((x.dates instanceof Set ? x.dates : [])).filter(Boolean).sort();
          const shown = dateArr.slice(0, 6).map((d) => {
            const dt = new Date(d);
            return isNaN(dt.getTime()) ? d : dt.toLocaleDateString("tr-TR");
          });
          const rest = dateArr.length - shown.length;
          const datesDisplay = shown.length ? (shown.join(", ") + (rest > 0 ? ` +${rest}` : "")) : "";
          const items = Array.isArray(x.items) ? x.items : [];
          const itemsSorted = items
            .slice()
            .sort((a, b) => {
              const da = String(a.date || "");
              const db = String(b.date || "");
              if (da !== db) return db.localeCompare(da);
              return String(a.start || "").localeCompare(String(b.start || ""));
            });
          return { label: x.label, visits: x.visits || 0, latestDate: x.latestDate || "", datesDisplay, items: itemsSorted };
        })
    );

    const toDeliveryList = (opKey) => {
      const list = Array.from(deliveryByOpJob.values()).filter((x) => x.opKey === opKey);
      return list
        .sort((a, b) => String(b.latestDate || "").localeCompare(String(a.latestDate || "")))
        .map((x) => {
          const dateArr = Array.from((x.dates instanceof Set ? x.dates : [])).filter(Boolean).sort();
          const shown = dateArr.slice(0, 6).map((d) => {
            const dt = new Date(d);
            return isNaN(dt.getTime()) ? String(d) : dt.toLocaleDateString("tr-TR");
          });
          const rest = dateArr.length - shown.length;
          const datesDisplay = shown.length ? (shown.join(", ") + (rest > 0 ? ` +${rest}` : "")) : "";
          return { ...x, datesDisplay };
        });
    };
    setDeliveryMontajJobs(toDeliveryList("EK_URUN_MONTAJI").slice(0, 20));
    setDeliveryDevreyeJobs(toDeliveryList("SISTEM_DEVREYE_ALMA").slice(0, 20));
    setTechQualityData(
      Array.from(techQualityMap.entries())
        .map(([name, rec]) => {
          const hours = (rec.sumMin || 0) / 60;
          const avgMinutes = rec.minCount ? (rec.sumMin / rec.minCount) : 0;
          const feeSum = rec.feeSum || 0;
          const avgFee = rec.feeCount ? (feeSum / rec.feeCount) : 0;
          const tryPerHour = hours > 0 ? (feeSum / hours) : 0;
          const formsPerHour = hours > 0 ? (rec.forms / hours) : 0;
          const paymentRate = (rec.forms ? ((rec.paid / rec.forms) * 100) : 0);
          const followRate = (rec.forms ? ((rec.follow / rec.forms) * 100) : 0);
          const deliveredRate = (rec.forms ? ((rec.delivered / rec.forms) * 100) : 0);
          const surveyAvg = (rec.surveyCount ? (rec.surveySum / rec.surveyCount) : 0);
          return {
            name,
            forms: rec.forms,
            hours: Math.round(hours * 10) / 10,
            avgMinutes: Math.round(avgMinutes),
            feeSum: Math.round(feeSum),
            avgFee: Math.round(avgFee),
            tryPerHour: Math.round(tryPerHour),
            formsPerHour: Math.round(formsPerHour * 100) / 100,
            paymentRate: Math.round(paymentRate),
            followRate: Math.round(followRate),
            deliveredRate: Math.round(deliveredRate),
            surveyAvg: Math.round(surveyAvg * 10) / 10,
            lowSurvey: rec.lowSurvey || 0,
          };
        })
        .sort((a, b) => (b.lowSurvey - a.lowSurvey) || (a.surveyAvg - b.surveyAvg))
    );
    setLowSurveyForms(lowSurveyList.sort((a, b) => String(b.service_date || "").localeCompare(String(a.service_date || ""))).slice(0, 200));
    return { paid, unpaid, sumFees, total: filtered.length };
  }, [period, monthSel, yearSel, payFilter, followFilter, deliveredFilter, deviceFilter, projectQuery, unpaidReasonFilter, opTypeFilter, minFee, maxFee, includeNoFee, startDate, endDate, deliveryStartDate, deliveryEndDate, startTime, endTime]);

  const [summary, setSummary] = React.useState({ total: 0, paid: 0, unpaid: 0, sumFees: 0 });

  React.useEffect(() => {
    let alive = true;
    (async () => {
      const all = await listForms();
      const t = await listTechnicians();
      if (!alive) return;
      setRows(all);
      setTechs(t);
      const s = compute(all);
      setSummary(s);
      try {
        const years = Array.from(new Set(all.map(f => {
          const d = new Date(f.service_date || f.created_at);
          return isNaN(d.getTime()) ? null : d.getFullYear();
        }).filter(Boolean))).sort((a, b) => b - a);
        if (years.length && yearSel === "all") setYearSel(String(years[0]));
      } catch (_) { }
    })();
    return () => { alive = false; };
  }, [compute]);

  React.useEffect(() => {
    const base = techFilter === "all" ? rows : rows.filter(r => ((r.technician && r.technician.name) || "") === techFilter);
    const s = compute(base);
    setSummary(s);
  }, [period, rows, compute, techFilter, monthSel, yearSel, payFilter, followFilter, deliveredFilter, deviceFilter, projectQuery, unpaidReasonFilter, opTypeFilter, minFee, maxFee, includeNoFee, startDate, endDate, deliveryStartDate, deliveryEndDate, startTime, endTime]);

  const COLORS = ["#3182CE", "#E53E3E"];
  const pageBg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.200", "whiteAlpha.200");
  const mutedText = useColorModeValue("gray.600", "gray.400");
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.100");
  const headerBg = useColorModeValue("linear(to-r, white, blue.50)", "linear(to-r, gray.800, blue.900)");
  const tabWrapBg = useColorModeValue("white", "gray.800");
  const tabWrapBorder = useColorModeValue("gray.200", "whiteAlpha.200");
  const tabHeaderBg = useColorModeValue("gray.50", "whiteAlpha.100");
  const cursorFill = useColorModeValue("rgba(0,0,0,0.05)", "rgba(255,255,255,0.05)");
  const trackBg = useColorModeValue("gray.100", "gray.700");
  const divBorderColor = useColorModeValue("gray.200", "gray.700");
  const textColorNum = useColorModeValue("gray.800", "white");
  const q1Bg = useColorModeValue("blue.50", "blue.900");
  const q1ColorText = useColorModeValue("blue.600", "blue.200");
  const q1ColorNum = useColorModeValue("blue.500", "blue.300");
  const q2Bg = useColorModeValue("green.50", "green.900");
  const q2ColorText = useColorModeValue("green.600", "green.200");
  const q2ColorNum = useColorModeValue("green.500", "green.300");
  const q3Bg = useColorModeValue("orange.50", "orange.900");
  const q3ColorText = useColorModeValue("orange.600", "orange.200");
  const q3ColorNum = useColorModeValue("orange.500", "orange.300");
  const q4Bg = useColorModeValue("purple.50", "purple.900");
  const q4ColorText = useColorModeValue("purple.600", "purple.200");
  const q4ColorNum = useColorModeValue("purple.500", "purple.300");


  const clearAllFilters = () => {
    setYearSel("all");
    setMonthSel("all");
    setTechFilter("all");
    applyPayFilter("all");
    setFollowFilter("all");
    setDeliveredFilter("all");
    setDeviceFilter("all");
    setProjectQuery("");
    setUnpaidReasonFilter("all");
    setOpTypeFilter("all");
    setMinFee("");
    setMaxFee("");
    setIncludeNoFee(true);
    setStartDate("");
    setEndDate("");
    setDeliveryStartDate("");
    setDeliveryEndDate("");
    setStartTime("");
    setEndTime("");
  };

  const hasActiveFilters = Boolean(
    (yearSel !== "all") ||
    (monthSel !== "all") ||
    (techFilter !== "all") ||
    (payFilter !== "all") ||
    (followFilter !== "all") ||
    (deliveredFilter !== "all") ||
    (deviceFilter !== "all") ||
    (unpaidReasonFilter !== "all") ||
    (opTypeFilter !== "all") ||
    projectQuery ||
    startDate ||
    endDate ||
    deliveryStartDate ||
    deliveryEndDate ||
    startTime ||
    endTime ||
    minFee ||
    maxFee ||
    !includeNoFee
  );

  const activeFilterCount = [
    yearSel !== "all",
    monthSel !== "all",
    techFilter !== "all",
    payFilter !== "all",
    followFilter !== "all",
    deliveredFilter !== "all",
    deviceFilter !== "all",
    unpaidReasonFilter !== "all",
    opTypeFilter !== "all",
    Boolean(projectQuery),
    Boolean(startDate),
    Boolean(endDate),
    Boolean(deliveryStartDate),
    Boolean(deliveryEndDate),
    Boolean(startTime),
    Boolean(endTime),
    Boolean(minFee),
    Boolean(maxFee),
    includeNoFee === false,
  ].filter(Boolean).length;

  const applyPayFilter = (mode) => {
    setPayFilter(mode);
    if (mode !== "unpaid") setUnpaidReasonFilter("all");
  };

  const opTypeLabel = React.useMemo(() => {
    if (opTypeFilter === "all") return "";
    const hit = opTypesData.find((x) => x && x.key === opTypeFilter);
    return hit?.name || String(opTypeFilter).replace(/_/g, " ");
  }, [opTypeFilter, opTypesData]);

  const periodLabel =
    period === "all"
      ? "Tüm zamanlar"
      : (period === "1"
        ? "Son 1 ay"
        : (period === "3"
          ? "Son çeyrek (1-3 ay)"
          : `Son ${period} ay`));
  const ymLabel = yearSel === "all" ? "Yıl: Hepsi" : (monthSel === "all" ? `Yıl: ${yearSel}` : `Ay: ${yearSel}-${monthSel}`);

  const techTopHours = React.useMemo(
    () => techQualityData.slice().sort((a, b) => (b.hours || 0) - (a.hours || 0)).slice(0, 12),
    [techQualityData]
  );
  const techTopCost = React.useMemo(
    () => techQualityData.slice().sort((a, b) => (b.feeSum || 0) - (a.feeSum || 0)).slice(0, 12),
    [techQualityData]
  );
  const techTopPerf = React.useMemo(
    () => techQualityData.slice().sort((a, b) => (b.formsPerHour || 0) - (a.formsPerHour || 0)).slice(0, 12),
    [techQualityData]
  );

  const fmt0 = React.useCallback((v) => {
    const n = Number(v);
    return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(isNaN(n) ? 0 : n);
  }, []);
  const fmt1 = React.useCallback((v) => {
    const n = Number(v);
    return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(isNaN(n) ? 0 : n);
  }, []);

  const monthOverviewData = React.useMemo(() => {
    const m = new Map();
    monthCountData.forEach((x) => {
      if (!x || !x.month) return;
      m.set(x.month, { month: x.month, forms: x.count || 0 });
    });
    monthSumData.forEach((x) => {
      if (!x || !x.month) return;
      const r = m.get(x.month) || { month: x.month, forms: 0 };
      r.totalTry = Math.round(Number(x.total) || 0);
      m.set(x.month, r);
    });
    monthlyAvgDuration.forEach((x) => {
      if (!x || !x.month) return;
      const r = m.get(x.month) || { month: x.month, forms: 0 };
      r.avgMin = Number(x.minutes) || 0;
      m.set(x.month, r);
    });
    monthlyPaymentRate.forEach((x) => {
      if (!x || !x.month) return;
      const r = m.get(x.month) || { month: x.month, forms: 0 };
      r.payRate = Number(x.rate) || 0;
      m.set(x.month, r);
    });
    monthlyFollowCountData.forEach((x) => {
      if (!x || !x.month) return;
      const r = m.get(x.month) || { month: x.month, forms: 0 };
      r.followCount = Number(x.count) || 0;
      m.set(x.month, r);
    });
    monthlyTotalWorkHours.forEach((x) => {
      if (!x || !x.month) return;
      const r = m.get(x.month) || { month: x.month, forms: 0 };
      const h = x.selectedHours ?? x.allHours ?? 0;
      r.hours = Number(h) || 0;
      m.set(x.month, r);
    });
    const keys = Array.from(m.keys()).sort();
    return keys.slice(Math.max(0, keys.length - 12)).map((k) => {
      const r = m.get(k) || { month: k };
      return {
        month: r.month,
        forms: r.forms || 0,
        hours: r.hours || 0,
        avgMin: r.avgMin || 0,
        totalTry: r.totalTry || 0,
        payRate: r.payRate || 0,
        followCount: r.followCount || 0,
      };
    });
  }, [monthCountData, monthSumData, monthlyAvgDuration, monthlyPaymentRate, monthlyFollowCountData, monthlyTotalWorkHours]);

  const monthlySurveyTable = React.useMemo(() => {
    const m = new Map();
    monthlySurveySummary.forEach((x) => {
      if (!x || !x.month) return;
      m.set(x.month, { month: x.month, avg: x.avg || 0, answered: x.count || 0 });
    });
    monthlySurveyStatusByMonth.forEach((x) => {
      if (!x || !x.month) return;
      const r = m.get(x.month) || { month: x.month, avg: 0, answered: 0 };
      r.success = x.success || 0;
      r.unreachable = x.unreachable || 0;
      r.refused = x.refused || 0;
      r.noPhone = x.noPhone || 0;
      m.set(x.month, r);
    });
    const keys = Array.from(m.keys()).sort();
    return keys.slice(Math.max(0, keys.length - 12)).map((k) => m.get(k));
  }, [monthlySurveySummary, monthlySurveyStatusByMonth]);

  const Card = ({ children, ...props }) => (
    <Box
      bg={cardBg}
      border="1px solid"
      borderColor={cardBorder}
      borderRadius="2xl"
      p={{ base: 4, md: 5 }}
      shadow="sm"
      transition="all 0.15s ease"
      _hover={{ shadow: "md" }}
      {...props}
    >
      {children}
    </Box>
  );

  const KpiCard = ({ label, value, helper, accent = "blue.500", icon }) => (
    <Box
      bg={cardBg}
      border="1px solid"
      borderColor={cardBorder}
      borderRadius="2xl"
      p={{ base: 4, md: 5 }}
      shadow="sm"
      position="relative"
      overflow="hidden"
      transition="all 0.15s ease"
      _hover={{ shadow: "md", transform: "translateY(-1px)" }}
    >
      <Box position="absolute" top={0} left={0} right={0} h="4px" bg={accent} />
      <HStack align="start" spacing={4}>
        <Box
          w="40px"
          h="40px"
          borderRadius="xl"
          bg={useColorModeValue("gray.50", "whiteAlpha.100")}
          border="1px solid"
          borderColor={cardBorder}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          {icon ? <Icon as={icon} color={accent} /> : null}
        </Box>
        <Stat>
          <StatLabel color={mutedText}>{label}</StatLabel>
          <StatNumber fontSize={{ base: "2xl", md: "3xl" }}>{value}</StatNumber>
          {helper ? <StatHelpText color={mutedText} mb={0}>{helper}</StatHelpText> : null}
        </Stat>
      </HStack>
    </Box>
  );

  return (
    <Box bg={pageBg} minH="100vh" py={{ base: 4, md: 6 }}>
      <Container maxW="1400px">
        <VStack align="stretch" spacing={5}>
          <Card bgGradient={headerBg} borderColor={cardBorder}>
            <HStack justify="space-between" align={{ base: "start", md: "center" }} wrap="wrap" spacing={4}>
              <VStack align="start" spacing={2}>
                <HStack spacing={3} wrap="wrap">
                  <Heading size="md">Form İstatistikleri</Heading>
                  {hasActiveFilters ? (
                    <Badge colorScheme="blue" borderRadius="full" px={3} py={1}>
                      {activeFilterCount} filtre aktif
                    </Badge>
                  ) : (
                    <Badge colorScheme="green" borderRadius="full" px={3} py={1}>
                      Filtre yok
                    </Badge>
                  )}
                </HStack>
                <Text fontSize="sm" color={mutedText}>
                  Özet, ödeme, operasyon ve anket metrikleri
                </Text>
                <HStack spacing={2} wrap="wrap">
                  <Badge variant="subtle" borderRadius="full" px={3} py={1}>{periodLabel}</Badge>
                  <Badge variant="subtle" borderRadius="full" px={3} py={1}>{ymLabel}</Badge>
                  <HStack spacing={1}>
                    {["1", "3", "6", "12", "24", "all"].map((p) => (
                      <Button
                        key={p}
                        size="xs"
                        variant={period === p ? "solid" : "outline"}
                        colorScheme="blue"
                        onClick={() => setPeriod(p)}
                      >
                        {p === "all" ? "Tümü" : (p === "3" ? "Çeyrek" : `${p} ay`)}
                      </Button>
                    ))}
                  </HStack>
                </HStack>
              </VStack>
              <HStack spacing={2} wrap="wrap" justify={{ base: "flex-start", md: "flex-end" }}>
                <Button size="sm" leftIcon={<FiList />} onClick={() => setIsListOpen(true)} variant="outline" colorScheme="green">
                  Liste ({filteredRows.length})
                </Button>
                <Button size="sm" leftIcon={<FiFilter />} onClick={() => setFiltersOpen(true)} colorScheme="blue">
                  Filtreler {hasActiveFilters ? <Badge ml={2} colorScheme="whiteAlpha" variant="solid" borderRadius="full" px={2} py={0.5}>{activeFilterCount}</Badge> : null}
                </Button>
                <Button size="sm" leftIcon={<FiUsers />} variant="outline" onClick={() => window.location.assign("/formlar/istatistik/teknisyen")}>
                  Teknisyen
                </Button>
              </HStack>
            </HStack>
          </Card>

          {hasActiveFilters && (
            <Card>
              <HStack justify="space-between" align="start" wrap="wrap" spacing={3} mb={3}>
                <VStack align="start" spacing={0}>
                  <Heading size="sm">Aktif Filtreler</Heading>
                  <Text fontSize="xs" color={mutedText}>İstatistikler bu filtrelere göre hesaplanır</Text>
                </VStack>
                <Button size="sm" variant="ghost" onClick={clearAllFilters}>Tümünü Temizle</Button>
              </HStack>
              <Box overflowX="auto">
                <Wrap>
                  {yearSel !== "all" && (<Tag size="md" colorScheme="blue"><TagLabel>Yıl: {yearSel}</TagLabel><TagCloseButton onClick={() => setYearSel("all")} /></Tag>)}
                  {monthSel !== "all" && (<Tag size="md" colorScheme="blue"><TagLabel>Ay: {monthSel}</TagLabel><TagCloseButton onClick={() => setMonthSel("all")} /></Tag>)}
                  {techFilter !== "all" && (<Tag size="md" colorScheme="purple"><TagLabel>Teknisyen: {techFilter}</TagLabel><TagCloseButton onClick={() => setTechFilter("all")} /></Tag>)}
                  {payFilter !== "all" && (<Tag size="md" colorScheme={payFilter === "paid" ? "green" : "red"}><TagLabel>Ödeme: {payFilter === "paid" ? "Alındı" : "Alınmadı"}</TagLabel><TagCloseButton onClick={() => applyPayFilter("all")} /></Tag>)}
                  {followFilter !== "all" && (<Tag size="md" colorScheme="orange"><TagLabel>Takip: {followFilter === "yes" ? "Gerekli" : "Gerekli Değil"}</TagLabel><TagCloseButton onClick={() => setFollowFilter("all")} /></Tag>)}
                  {deliveredFilter !== "all" && (<Tag size="md" colorScheme="teal"><TagLabel>Teslim: {deliveredFilter === "yes" ? "Çalışır" : "Çalışır Değil"}</TagLabel><TagCloseButton onClick={() => setDeliveredFilter("all")} /></Tag>)}
                  {deviceFilter !== "all" && (<Tag size="md" colorScheme="cyan"><TagLabel>Cihaz: {deviceFilter}</TagLabel><TagCloseButton onClick={() => setDeviceFilter("all")} /></Tag>)}
                  {opTypeFilter !== "all" && (<Tag size="md" colorScheme="purple"><TagLabel>İşlem: {opTypeLabel}</TagLabel><TagCloseButton onClick={() => setOpTypeFilter("all")} /></Tag>)}
                  {unpaidReasonFilter !== "all" && (<Tag size="md" colorScheme="red"><TagLabel>Neden: {unpaidReasonFilter}</TagLabel><TagCloseButton onClick={() => setUnpaidReasonFilter("all")} /></Tag>)}
                  {projectQuery && (<Tag size="md"><TagLabel>Proje: {projectQuery}</TagLabel><TagCloseButton onClick={() => setProjectQuery("")} /></Tag>)}
                  {startDate && (<Tag size="md" colorScheme="blue"><TagLabel>Bşl: {startDate}</TagLabel><TagCloseButton onClick={() => setStartDate("")} /></Tag>)}
                  {endDate && (<Tag size="md" colorScheme="blue"><TagLabel>Btiş: {endDate}</TagLabel><TagCloseButton onClick={() => setEndDate("")} /></Tag>)}
                  {(deliveryStartDate || deliveryEndDate) && (
                    <Tag size="md" colorScheme="teal">
                      <TagLabel>Teslim: {deliveryStartDate || "…"} - {deliveryEndDate || "…"}</TagLabel>
                      <TagCloseButton onClick={() => { setDeliveryStartDate(""); setDeliveryEndDate(""); }} />
                    </Tag>
                  )}
                  {(startTime || endTime) && (<Tag size="md" colorScheme="orange"><TagLabel>Saat: {startTime || "00:00"} - {endTime || "23:59"}</TagLabel><TagCloseButton onClick={() => { setStartTime(""); setEndTime(""); }} /></Tag>)}
                  {(minFee || maxFee || !includeNoFee) && (<Tag size="md" colorScheme="gray"><TagLabel>Ücret: {minFee || 0} - {maxFee || "∞"} {includeNoFee ? "" : " (ücretsiz hariç)"}</TagLabel><TagCloseButton onClick={() => { setMinFee(""); setMaxFee(""); setIncludeNoFee(true); }} /></Tag>)}
                </Wrap>
              </Box>
            </Card>
          )}

          <Drawer isOpen={filtersOpen} placement="right" onClose={() => setFiltersOpen(false)}>
            <DrawerOverlay />
            <DrawerContent>
              <DrawerHeader borderBottomWidth="1px">Filtreler</DrawerHeader>
              <DrawerBody>
                <VStack align="stretch" spacing={4}>
                  <HStack>
                    <Select value={yearSel} onChange={(e) => setYearSel(e.target.value)}>
                      <option value="all">Yıl: Hepsi</option>
                      {Array.from(new Set(rows.map(r => {
                        const d = new Date(r.service_date || r.created_at);
                        return isNaN(d.getTime()) ? null : d.getFullYear();
                      }).filter(Boolean))).sort((a, b) => b - a).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </Select>
                    <Select value={monthSel} onChange={(e) => setMonthSel(e.target.value)}>
                      <option value="all">Ay: Hepsi</option>
                      {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].map(m => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </Select>
                  </HStack>
                  <Select value={period} onChange={(e) => setPeriod(e.target.value)}>
                    <option value="all">Tüm Zamanlar</option>
                    <option value="1">Son 1 Ay</option>
                    <option value="3">Son çeyrek (1-3 ay)</option>
                    <option value="6">Son 6 Ay</option>
                    <option value="12">Son 12 Ay</option>
                    <option value="24">Son 24 Ay</option>
                  </Select>
                  <Select value={techFilter} onChange={(e) => setTechFilter(e.target.value)}>
                    <option value="all">Teknisyen: Hepsi</option>
                    {techs.map((t) => (
                      <option key={t.id} value={t.name}>{t.name}</option>
                    ))}
                  </Select>
                  <Select value={payFilter} onChange={(e) => applyPayFilter(e.target.value)}>
                    <option value="all">Ödeme: Hepsi</option>
                    <option value="paid">Alındı</option>
                    <option value="unpaid">Alınmadı</option>
                  </Select>
                  <Select value={unpaidReasonFilter} onChange={(e) => setUnpaidReasonFilter(e.target.value)}>
                    <option value="all">Neden: Hepsi</option>
                    <option value="Tanıdık">Tanıdık</option>
                    <option value="Garanti kapsamında">Garanti kapsamında</option>
                    <option value="Teknik sorun">Teknik sorun</option>
                    <option value="Diğer">Diğer</option>
                  </Select>
                  <Select value={followFilter} onChange={(e) => setFollowFilter(e.target.value)}>
                    <option value="all">Takip: Hepsi</option>
                    <option value="yes">Gerekli</option>
                    <option value="no">Gerekli Değil</option>
                  </Select>
                  <Select value={deliveredFilter} onChange={(e) => setDeliveredFilter(e.target.value)}>
                    <option value="all">Teslim: Hepsi</option>
                    <option value="yes">Çalışır</option>
                    <option value="no">Çalışır Değil</option>
                  </Select>
                  <Select value={opTypeFilter} onChange={(e) => setOpTypeFilter(e.target.value)}>
                    <option value="all">İşlem: Hepsi</option>
                    {opTypesData.map((o) => (
                      <option key={o.key || o.name} value={o.key || o.name}>{o.name}</option>
                    ))}
                  </Select>
                  <Select value={deviceFilter} onChange={(e) => setDeviceFilter(e.target.value)}>
                    <option value="all">Cihaz: Hepsi</option>
                    {Array.from(new Set(rows.map(r => r.device_type || "Bilinmiyor"))).sort().map(d => (
                      <option key={d} value={d}>{d}</option>
                    ))}
                  </Select>
                  <Input placeholder="Proje ara" value={projectQuery} onChange={(e) => setProjectQuery(e.target.value)} />

                  <Box>
                    <Text fontSize="sm" fontWeight="bold" mb={2}>Tarih Aralığı</Text>
                    <HStack>
                      <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                      <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                    </HStack>
                  </Box>

                  <Box>
                    <Text fontSize="sm" fontWeight="bold" mb={2}>Teslim Tarihi Aralığı</Text>
                    <HStack>
                      <Input type="date" value={deliveryStartDate} onChange={(e) => setDeliveryStartDate(e.target.value)} />
                      <Input type="date" value={deliveryEndDate} onChange={(e) => setDeliveryEndDate(e.target.value)} />
                    </HStack>
                  </Box>

                  <Box>
                    <Text fontSize="sm" fontWeight="bold" mb={2}>Saat Aralığı</Text>
                    <HStack>
                      <Input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                      <Input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                    </HStack>
                  </Box>

                  <HStack>
                    <Input type="number" placeholder="Min ₺" value={minFee} onChange={(e) => setMinFee(e.target.value)} />
                    <Input type="number" placeholder="Max ₺" value={maxFee} onChange={(e) => setMaxFee(e.target.value)} />
                  </HStack>
                  <Checkbox isChecked={includeNoFee} onChange={(e) => setIncludeNoFee(e.target.checked)}>Ücreti olmayanları dahil et</Checkbox>
                </VStack>
              </DrawerBody>
              <DrawerFooter>
                <HStack w="100%" justify="space-between">
                  <Button variant="ghost" onClick={() => setFiltersOpen(false)}>Kapat</Button>
                  <HStack>
                    <Button variant="outline" onClick={() => {
                      clearAllFilters();
                    }}>Temizle</Button>
                    <Button colorScheme="blue" onClick={() => setFiltersOpen(false)}>Uygula</Button>
                  </HStack>
                </HStack>
              </DrawerFooter>
            </DrawerContent>
          </Drawer>

          <Box
            bg={tabWrapBg}
            border="1px solid"
            borderColor={tabWrapBorder}
            borderRadius="2xl"
            shadow="sm"
            overflow="hidden"
          >
            <Tabs variant="unstyled" colorScheme="blue" isLazy>
              <Box
                px={{ base: 3, md: 4 }}
                py={{ base: 3, md: 4 }}
                borderBottomWidth="1px"
                borderColor={tabWrapBorder}
                bg={tabHeaderBg}
                position="sticky"
                top="0"
                zIndex={1}
              >
                <HStack spacing={3} wrap="wrap">
                  <VStack align="start" spacing={0} minW={{ base: "100%", md: "auto" }}>
                    <Text fontWeight="bold">Paneller</Text>
                    <Text fontSize="xs" color={mutedText}>İstatistikler aynı, sadece görünüm düzenlendi</Text>
                  </VStack>
                  <Spacer />
                  <TabList>
                    <HStack spacing={2} overflowX="auto" py={1}>
                      <Tab
                        px={3}
                        py={2}
                        borderRadius="xl"
                        bg={useColorModeValue("white", "whiteAlpha.100")}
                        border="1px solid"
                        borderColor={tabWrapBorder}
                        flexShrink={0}
                        transition="all 0.15s ease"
                        _hover={{ transform: "translateY(-1px)" }}
                        _selected={{ bg: "blue.500", color: "white", borderColor: "blue.500" }}
                      >
                        <HStack spacing={2}>
                          <FiBarChart2 />
                          <Text>Özet</Text>
                        </HStack>
                      </Tab>
                      <Tab
                        px={3}
                        py={2}
                        borderRadius="xl"
                        bg={useColorModeValue("white", "whiteAlpha.100")}
                        border="1px solid"
                        borderColor={tabWrapBorder}
                        flexShrink={0}
                        transition="all 0.15s ease"
                        _hover={{ transform: "translateY(-1px)" }}
                        _selected={{ bg: "blue.500", color: "white", borderColor: "blue.500" }}
                      >
                        <HStack spacing={2}>
                          <FiCreditCard />
                          <Text>Ödeme</Text>
                        </HStack>
                      </Tab>
                      <Tab
                        px={3}
                        py={2}
                        borderRadius="xl"
                        bg={useColorModeValue("white", "whiteAlpha.100")}
                        border="1px solid"
                        borderColor={tabWrapBorder}
                        flexShrink={0}
                        transition="all 0.15s ease"
                        _hover={{ transform: "translateY(-1px)" }}
                        _selected={{ bg: "blue.500", color: "white", borderColor: "blue.500" }}
                      >
                        <HStack spacing={2}>
                          <FiTool />
                          <Text>Operasyon</Text>
                        </HStack>
                      </Tab>
                      <Tab
                        px={3}
                        py={2}
                        borderRadius="xl"
                        bg={useColorModeValue("white", "whiteAlpha.100")}
                        border="1px solid"
                        borderColor={tabWrapBorder}
                        flexShrink={0}
                        transition="all 0.15s ease"
                        _hover={{ transform: "translateY(-1px)" }}
                        _selected={{ bg: "blue.500", color: "white", borderColor: "blue.500" }}
                      >
                        <HStack spacing={2}>
                          <FiUsers />
                          <Text>Anket</Text>
                        </HStack>
                      </Tab>
                    </HStack>
                  </TabList>
                </HStack>
              </Box>
              <TabPanels>
                {/* ÖZET (SUMMARY) TAB */}
                <TabPanel px={0}>
                  <Box px={{ base: 4, md: 5 }} pt={{ base: 4, md: 5 }}>
                    <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={5}>
                      <KpiCard label="Toplam Form" value={summary.total} helper="Filtreye göre" accent="blue.500" icon={FiBarChart2} />
                      <KpiCard label="Aylık Ortalama Form" value={monthlyAvgCount.toFixed(1)} helper="Aylık ortalama adet" accent="cyan.500" icon={FiTrendingUp} />
                      <KpiCard label="Ödeme Alındı" value={summary.paid} accent="green.500" icon={FiCheckCircle} />
                      <KpiCard label="Ödeme Alınmadı" value={summary.unpaid} accent="red.500" icon={FiXCircle} />
                    </SimpleGrid>
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={5} mt={5}>
                      <KpiCard
                        label="Toplam Tutar"
                        value={new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(summary.sumFees || 0) + " ₺"}
                        accent="purple.500"
                        icon={FaTurkishLiraSign}
                      />
                      <KpiCard
                        label="Ortalama Ücret"
                        value={new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(avgFee || 0) + " ₺"}
                        accent="teal.500"
                        icon={FiCreditCard}
                      />
                      <KpiCard
                        label="Anket Ortalaması"
                        value={new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(overallSurveyAvg || 0)}
                        accent="yellow.500"
                        icon={FiUsers}
                      />
                    </SimpleGrid>

                    <Divider my={6} borderColor={divBorderColor} />

                    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
                      <Card>
                        <Heading size="md" mb={2}>Aylık Form Trendi</Heading>
                        <Text fontSize="sm" color={mutedText} mb={6}>Son 12 ayın form sayıları ve değişim oranları</Text>
                        <ResponsiveContainer width="100%" height={300}>
                          <ComposedChart data={monthCountData}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.3} />
                            <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dy={10} />
                            <YAxis yAxisId="left" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dx={-10} />
                            <Tooltip contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} cursor={{ fill: cursorFill }} />
                            <Legend wrapperStyle={{ paddingTop: "20px" }} />
                            <Bar yAxisId="left" dataKey="count" name="Form Adedi" fill="#3182CE" radius={[8, 8, 0, 0]} barSize={40} />
                            <Line yAxisId="left" type="monotone" dataKey="changePct" name="Değişim %" stroke="#E53E3E" strokeWidth={3} dot={{ r: 4, strokeWidth: 2 }} activeDot={{ r: 6 }} />
                          </ComposedChart>
                        </ResponsiveContainer>
                      </Card>
                      <Card>
                        <Heading size="md" mb={2}>Aylık Ciro Trendi</Heading>
                        <Text fontSize="sm" color={mutedText} mb={6}>Aylara göre toplam tahsilat tutarları</Text>
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={monthSumData}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.3} />
                            <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dy={10} />
                            <YAxis axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dx={-10} tickFormatter={(v) => v >= 1000 ? `${v / 1000}k` : v} />
                            <Tooltip formatter={(v) => [`${fmt0(v)} ₺`, "Ciro"]} contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} cursor={{ fill: cursorFill }} />
                            <Bar dataKey="total" name="Ciro (₺)" fill="#805AD5" radius={[8, 8, 0, 0]} barSize={40} />
                          </BarChart>
                        </ResponsiveContainer>
                      </Card>
                    </SimpleGrid>

                    <Card mt={6}>
                      <HStack justify="space-between" mb={4}>
                        <VStack align="start" spacing={1}>
                          <Heading size="md">Personel Performans Özeti</Heading>
                          <Text fontSize="sm" color={mutedText}>Teknisyenlerin genel metrikleri</Text>
                        </VStack>
                      </HStack>
                      <Box overflowX="auto">
                        <ModernTable
                          data={techQualityData.slice(0, 10)}
                          columns={[
                            { title: "Teknisyen", dataIndex: "name" },
                            { title: "Form", dataIndex: "forms" },
                            { title: "Ciro (₺)", dataIndex: "feeSum", render: (v) => fmt0(v) },
                            {
                              title: "Anket Ort.", dataIndex: "surveyAvg", render: (v) => (
                                <Badge colorScheme={v >= 4 ? "green" : v >= 3 ? "yellow" : "red"} borderRadius="full" px={2}>
                                  {fmt1(v)}
                                </Badge>
                              )
                            }
                          ]}
                          searchable={false}
                          pageSize={10}
                          onRowClick={(row) => setTechFilter((prev) => (prev === row?.name ? "all" : row?.name || "all"))}
                        />
                      </Box>
                    </Card>
                  </Box>
                </TabPanel>

                {/* ÖDEME (PAYMENT) TAB */}
                <TabPanel px={0}>
                  <Box px={{ base: 4, md: 5 }} py={{ base: 4, md: 5 }}>
                    <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={6} mb={6}>
                      <Card gridColumn={{ lg: "span 1" }}>
                        <Heading size="md" mb={6}>Ödeme Dağılımı</Heading>
                        <Box position="relative" height="280px" display="flex" alignItems="center" justifyContent="center">
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={paymentData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={70}
                                outerRadius={100}
                                stroke="none"
                                paddingAngle={5}
                                onClick={(slice) => {
                                  if (!slice || !slice.name) return;
                                  applyPayFilter(slice.name === "Alındı" ? "paid" : "unpaid");
                                }}
                              >
                                {paymentData.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={entry.name === "Alındı" ? "#38A169" : "#E53E3E"} />
                                ))}
                              </Pie>
                              <Tooltip contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} />
                            </PieChart>
                          </ResponsiveContainer>
                          <VStack position="absolute" pointerEvents="none" spacing={0}>
                            <Text fontSize="3xl" fontWeight="bold" color={textColorNum}>{Math.round((summary.paid / (summary.total || 1)) * 100)}%</Text>
                            <Text fontSize="xs" color={mutedText}>Tahsilat Oranı</Text>
                          </VStack>
                        </Box>
                        <HStack justify="center" mt={4} spacing={6}>
                          <HStack
                            cursor="pointer"
                            px={3}
                            py={1}
                            borderRadius="lg"
                            _hover={{ bg: hoverBg }}
                            onClick={() => applyPayFilter("paid")}
                          >
                            <Box w={3} h={3} borderRadius="full" bg="#38A169" />
                            <Text fontSize="sm">Alındı ({summary.paid})</Text>
                          </HStack>
                          <HStack
                            cursor="pointer"
                            px={3}
                            py={1}
                            borderRadius="lg"
                            _hover={{ bg: hoverBg }}
                            onClick={() => applyPayFilter("unpaid")}
                          >
                            <Box w={3} h={3} borderRadius="full" bg="#E53E3E" />
                            <Text fontSize="sm">Alınmadı ({summary.unpaid})</Text>
                          </HStack>
                        </HStack>
                      </Card>

                      <Card gridColumn={{ lg: "span 2" }}>
                        <Heading size="md" mb={2}>Ödeme Alınmama Nedenleri</Heading>
                        <Text fontSize="sm" color={mutedText} mb={6}>Hangi sebeplerle ücret tahsil edilemedi?</Text>
                        <VStack align="stretch" spacing={5}>
                          {unpaidReasons.length > 0 ? unpaidReasons.map((r, i) => {
                            const max = Math.max(...unpaidReasons.map(x => x.count));
                            const pct = (r.count / max) * 100;
                            const colors = ["red.500", "orange.400", "yellow.500", "gray.500"];
                            return (
                              <Box
                                key={r.name}
                                cursor="pointer"
                                borderRadius="lg"
                                px={2}
                                py={2}
                                _hover={{ bg: hoverBg }}
                                onClick={() => {
                                  applyPayFilter("unpaid");
                                  setUnpaidReasonFilter((prev) => (prev === r.name ? "all" : r.name));
                                }}
                              >
                                <HStack justify="space-between" mb={1}>
                                  <Text fontWeight="medium" fontSize="sm">{r.name}</Text>
                                  <Text fontWeight="bold" fontSize="sm">{r.count} form</Text>
                                </HStack>
                                <Box w="100%" bg={trackBg} borderRadius="full" h="8px" overflow="hidden">
                                  <Box w={`${pct}%`} bg={colors[i % colors.length]} h="100%" borderRadius="full" transition="width 1s ease-in-out" />
                                </Box>
                              </Box>
                            );
                          }) : (
                            <Text color={mutedText} textAlign="center" py={10}>Kayıtlı veri bulunamadı.</Text>
                          )}
                        </VStack>
                      </Card>
                    </SimpleGrid>

                    <Card>
                      <Heading size="md" mb={2}>Aylık Tahsilat Performansı</Heading>
                      <Text fontSize="sm" color={mutedText} mb={6}>Aylara göre ödeme alınma oranları (%)</Text>
                      <ResponsiveContainer width="100%" height={300}>
                        <AreaChart data={monthlyPaymentRate}>
                          <defs>
                            <linearGradient id="colorPayRate" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="#38A169" stopOpacity={0.5} />
                              <stop offset="95%" stopColor="#38A169" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.3} />
                          <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dy={10} />
                          <YAxis axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dx={-10} domain={[0, 100]} />
                          <Tooltip formatter={(v) => [`${v}%`, "Ödeme Oranı"]} contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} />
                          <Area type="monotone" dataKey="rate" name="Tahsilat %" stroke="#38A169" strokeWidth={3} fillOpacity={1} fill="url(#colorPayRate)" />
                        </AreaChart>
                      </ResponsiveContainer>
                    </Card>
                  </Box>
                </TabPanel>

                {/* OPERASYON (OPERATION) TAB */}
                <TabPanel px={0}>
                  <Box px={{ base: 4, md: 5 }} py={{ base: 4, md: 5 }}>
                    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6} mb={6}>
                      <Card>
                        <Heading size="md" mb={6}>Cihaz Tipi Dağılımı</Heading>
                        <VStack align="stretch" spacing={5} maxH="400px" overflowY="auto" pr={2}>
                          {deviceData.map((d, i) => {
                            const max = Math.max(...deviceData.map(x => x.count));
                            const pct = (d.count / max) * 100;
                            return (
                              <Box
                                key={d.name}
                                cursor="pointer"
                                borderRadius="lg"
                                px={2}
                                py={2}
                                _hover={{ bg: hoverBg }}
                                onClick={() => setDeviceFilter((prev) => (prev === d.name ? "all" : d.name))}
                              >
                                <HStack justify="space-between" mb={1}>
                                  <Text fontWeight="medium" fontSize="sm" noOfLines={1} title={d.name}>{d.name}</Text>
                                  <Text fontWeight="bold" fontSize="sm">{d.count}</Text>
                                </HStack>
                                <Box w="100%" bg={trackBg} borderRadius="full" h="8px" overflow="hidden">
                                  <Box w={`${pct}%`} bg="blue.400" h="100%" borderRadius="full" />
                                </Box>
                              </Box>
                            );
                          })}
                        </VStack>
                      </Card>

                      <Card>
                        <Heading size="md" mb={6}>İşlem Tipleri</Heading>
                        <VStack align="stretch" spacing={5} maxH="400px" overflowY="auto" pr={2}>
                          {opTypesData.map((o, i) => {
                            const max = Math.max(...opTypesData.map(x => x.count));
                            const pct = (o.count / max) * 100;
                            return (
                              <Box
                                key={o.key || o.name}
                                cursor="pointer"
                                borderRadius="lg"
                                px={2}
                                py={2}
                                _hover={{ bg: hoverBg }}
                                onClick={() => setOpTypeFilter((prev) => (prev === (o.key || o.name) ? "all" : (o.key || o.name)))}
                              >
                                <HStack justify="space-between" mb={1}>
                                  <Text fontWeight="medium" fontSize="sm" textTransform="capitalize">{o.name.toLowerCase()}</Text>
                                  <Text fontWeight="bold" fontSize="sm">{o.count}</Text>
                                </HStack>
                                <Box w="100%" bg={trackBg} borderRadius="full" h="8px" overflow="hidden">
                                  <Box w={`${pct}%`} bg="purple.400" h="100%" borderRadius="full" />
                                </Box>
                              </Box>
                            );
                          })}
                        </VStack>
                      </Card>
                    </SimpleGrid>

                    <Card mb={6}>
                      <Heading size="md" mb={2}>Saat Aralığı Yoğunluğu</Heading>
                      <Text fontSize="sm" color={mutedText} mb={6}>Servislerin başlangıç saatlerine göre dağılımı</Text>
                      <ResponsiveContainer width="100%" height={260}>
                        <BarChart data={hourBucketData}>
                          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.3} />
                          <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dy={10} />
                          <YAxis axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dx={-10} />
                          <Tooltip contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} cursor={{ fill: cursorFill }} />
                          <Bar dataKey="count" name="Adet" fill="#DD6B20" radius={[8, 8, 0, 0]} barSize={50}>
                            {hourBucketData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.count === Math.max(...hourBucketData.map(d => d.count)) ? "#C05621" : "#F6AD55"} />
                            ))}
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </Card>
                  </Box>
                </TabPanel>

                {/* ANKET (SURVEY) TAB */}
                <TabPanel px={0}>
                  <Box px={{ base: 4, md: 5 }} py={{ base: 4, md: 5 }}>
                    <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4} mb={6}>
                      <Box bg={q1Bg} p={4} borderRadius="2xl" textAlign="center">
                        <Text color={q1ColorText} fontSize="sm" mb={1} fontWeight="medium">Memnuniyet (Q1)</Text>
                        <Text fontSize="3xl" fontWeight="bold" color={q1ColorNum}>{fmt1(monthlyQSeries.length ? monthlyQSeries[monthlyQSeries.length - 1]?.q1 : 0)}</Text>
                      </Box>
                      <Box bg={q2Bg} p={4} borderRadius="2xl" textAlign="center">
                        <Text color={q2ColorText} fontSize="sm" mb={1} fontWeight="medium">İletişim (Q2)</Text>
                        <Text fontSize="3xl" fontWeight="bold" color={q2ColorNum}>{fmt1(monthlyQSeries.length ? monthlyQSeries[monthlyQSeries.length - 1]?.q2 : 0)}</Text>
                      </Box>
                      <Box bg={q3Bg} p={4} borderRadius="2xl" textAlign="center">
                        <Text color={q3ColorText} fontSize="sm" mb={1} fontWeight="medium">Zamanında (Q3)</Text>
                        <Text fontSize="3xl" fontWeight="bold" color={q3ColorNum}>{fmt1(monthlyQSeries.length ? monthlyQSeries[monthlyQSeries.length - 1]?.q3 : 0)}</Text>
                      </Box>
                      <Box bg={q4Bg} p={4} borderRadius="2xl" textAlign="center">
                        <Text color={q4ColorText} fontSize="sm" mb={1} fontWeight="medium">Çözüm (Q4)</Text>
                        <Text fontSize="3xl" fontWeight="bold" color={q4ColorNum}>{fmt1(monthlyQSeries.length ? monthlyQSeries[monthlyQSeries.length - 1]?.q4 : 0)}</Text>
                      </Box>
                    </SimpleGrid>

                    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6} mb={6}>
                      <Card>
                        <Heading size="md" mb={2}>Anket Ortalaması Trendi</Heading>
                        <Text fontSize="sm" color={mutedText} mb={6}>Aylık genel anket memnuniyet puanı</Text>
                        <ResponsiveContainer width="100%" height={260}>
                          <AreaChart data={monthlySurveySummary}>
                            <defs>
                              <linearGradient id="colorSurvey" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#ECC94B" stopOpacity={0.5} />
                                <stop offset="95%" stopColor="#ECC94B" stopOpacity={0} />
                              </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.3} />
                            <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dy={10} />
                            <YAxis domain={[0, 5]} axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} dx={-10} />
                            <Tooltip contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} />
                            <Area type="monotone" dataKey="avg" name="Ortalama" stroke="#D69E2E" strokeWidth={3} fillOpacity={1} fill="url(#colorSurvey)" />
                          </AreaChart>
                        </ResponsiveContainer>
                      </Card>

                      <Card>
                        <Heading size="md" mb={2}>Anket Durum Dağılımı</Heading>
                        <Text fontSize="sm" color={mutedText} mb={6}>Ulaşılamayan veya reddedilen anketler</Text>
                        <ResponsiveContainer width="100%" height={260}>
                          <BarChart data={monthlySurveyStatusByMonth} layout="vertical">
                            <CartesianGrid strokeDasharray="3 3" horizontal={false} opacity={0.3} />
                            <XAxis type="number" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} />
                            <YAxis type="category" dataKey="month" axisLine={false} tickLine={false} tick={{ fill: mutedText, fontSize: 12 }} width={60} />
                            <Tooltip contentStyle={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)" }} cursor={{ fill: cursorFill }} />
                            <Legend wrapperStyle={{ paddingTop: "10px" }} />
                            <Bar dataKey="success" name="Başarılı" stackId="a" fill="#48BB78" radius={[0, 0, 0, 0]} />
                            <Bar dataKey="unreachable" name="Ulaşılamadı" stackId="a" fill="#F56565" />
                            <Bar dataKey="refused" name="İstemedi" stackId="a" fill="#ED8936" />
                            <Bar dataKey="noPhone" name="Numara Yok" stackId="a" fill="#A0AEC0" radius={[0, 8, 8, 0]} />
                          </BarChart>
                        </ResponsiveContainer>
                      </Card>
                    </SimpleGrid>

                    <Card>
                      <Heading size="md" mb={2}>Teknisyen Anket Ortalamaları</Heading>
                      <Text fontSize="sm" color={mutedText} mb={6}>Müşterilerin teknisyenlere verdiği ortalama puanlar (1-5)</Text>
                      <VStack align="stretch" spacing={5}>
                        {techSurveyAvgData.slice(0, 10).map((t, i) => {
                          const pct = (t.avg / 5) * 100;
                          return (
                            <Box key={t.name}>
                              <HStack justify="space-between" mb={1}>
                                <Text fontWeight="medium" fontSize="sm">{t.name}</Text>
                                <HStack spacing={2}>
                                  <Icon as={FiUsers} color={mutedText} />
                                  <Text fontWeight="bold" fontSize="sm">{fmt1(t.avg)}</Text>
                                </HStack>
                              </HStack>
                              <Box w="100%" bg={trackBg} borderRadius="full" h="8px" overflow="hidden">
                                <Box w={`${pct}%`} bg={t.avg >= 4 ? "green.400" : t.avg >= 3 ? "yellow.400" : "red.400"} h="100%" borderRadius="full" transition="width 1s ease-in-out" />
                              </Box>
                            </Box>
                          );
                        })}
                      </VStack>
                    </Card>
                  </Box>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>


          <Modal isOpen={isListOpen} onClose={() => setIsListOpen(false)} size="full">
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Filtrelenen Formlar ({filteredRows.length})</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <ModernTable
                  data={filteredRows}
                  getRowProps={(row) => {
                    const avg = getSurveyAvg(row);
                    if (avg != null && avg < 3) {
                      return { bg: "red.50", _hover: { bg: "red.50", transform: "none" } };
                    }
                    return {};
                  }}
                  columns={[
                    { title: "Seri No", dataIndex: "serial_number", sortable: true },
                    { title: "Müşteri", dataIndex: "customer_name", sortable: true },
                    { title: "Proje", dataIndex: "project_name", sortable: true },
                    {
                      title: "Servis Tarihi",
                      dataIndex: "service_date",
                      sortable: true,
                      render: (v, row) => v || (row.created_at ? new Date(row.created_at).toLocaleDateString() : "-")
                    },
                    {
                      title: "Saat",
                      dataIndex: "service_start_time",
                      render: (v, row) => `${v || "00:00"} - ${row.service_end_time || "00:00"}`
                    },
                    {
                      title: "Teknisyenler",
                      render: (_, row) => {
                        const names = [];
                        if (row.technician) names.push(row.technician.name);
                        if (Array.isArray(row.team)) row.team.forEach(t => names.push(t.name));
                        return names.join(", ") || "-";
                      }
                    }
                  ]}
                  actions={[
                    {
                      label: "Görüntüle",
                      icon: FiEye,
                      onClick: (row) => navigate(`/formlar/${row.id}`),
                    }
                  ]}
                  onRowClick={(row) => navigate(`/formlar/${row.id}`)}
                  searchable={true}
                  pageSize={20}
                />
              </ModalBody>
            </ModalContent>
          </Modal>

          <Modal
            isOpen={opDatesOpen}
            onClose={() => {
              setOpDatesOpen(false);
              setSelectedOpJob(null);
            }}
            size="lg"
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>{selectedOpJob?.label || "Ziyaret Detayı"}</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <HStack justify="space-between" mb={3}>
                  <Text fontSize="sm" color="gray.600">Toplam ziyaret: <Text as="span" fontWeight="bold" color="gray.800">{selectedOpJob?.visits || 0}</Text></Text>
                  {selectedOpJob?.latestDate ? (
                    <Text fontSize="sm" color="gray.600">
                      Son: <Text as="span" fontWeight="bold" color="gray.800">{new Date(selectedOpJob.latestDate).toLocaleDateString("tr-TR")}</Text>
                    </Text>
                  ) : null}
                </HStack>

                <ModernTable
                  data={Array.isArray(selectedOpJob?.items) ? selectedOpJob.items : []}
                  columns={[
                    {
                      title: "Tarih",
                      dataIndex: "date",
                      sortable: true,
                      render: (v) => (v ? new Date(v).toLocaleDateString("tr-TR") : "-"),
                    },
                    {
                      title: "Saat",
                      render: (_, row) => {
                        const s = row.start || "";
                        const e = row.end || "";
                        return s || e ? `${s || "00:00"} - ${e || "00:00"}` : "-";
                      },
                    },
                    { title: "İşlem", dataIndex: "op", sortable: true },
                    { title: "Seri No", dataIndex: "serial", sortable: true },
                  ]}
                  actions={[
                    {
                      label: "Görüntüle",
                      icon: FiEye,
                      onClick: (row) => row?.id && navigate(`/formlar/${row.id}`),
                    },
                  ]}
                  onRowClick={(row) => row?.id && navigate(`/formlar/${row.id}`)}
                  searchable={true}
                  pageSize={12}
                />
              </ModalBody>
            </ModalContent>
          </Modal>

          <Modal
            isOpen={deliveryJobOpen}
            onClose={() => {
              setDeliveryJobOpen(false);
              setSelectedDeliveryJob(null);
            }}
            size="xl"
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                {selectedDeliveryJob?.label || "Teslim Detayı"}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <HStack justify="space-between" mb={3} wrap="wrap">
                  <Text fontSize="sm" color="gray.600">
                    İşlem:{" "}
                    <Text as="span" fontWeight="bold" color="gray.800">
                      {selectedDeliveryJob?.opKey === "EK_URUN_MONTAJI"
                        ? "EK ÜRÜN MONTAJI"
                        : selectedDeliveryJob?.opKey === "SISTEM_DEVREYE_ALMA"
                          ? "SİSTEM DEVREYE ALMA"
                          : "-"}
                    </Text>
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    Toplam:{" "}
                    <Text as="span" fontWeight="bold" color="gray.800">
                      {selectedDeliveryJob?.visits || 0}
                    </Text>
                  </Text>
                  {selectedDeliveryJob?.latestDate ? (
                    <Text fontSize="sm" color="gray.600">
                      Son:{" "}
                      <Text as="span" fontWeight="bold" color="gray.800">
                        {new Date(selectedDeliveryJob.latestDate).toLocaleDateString("tr-TR")}
                      </Text>
                    </Text>
                  ) : null}
                </HStack>

                <ModernTable
                  data={(Array.isArray(selectedDeliveryJob?.items) ? selectedDeliveryJob.items : [])
                    .slice()
                    .sort((a, b) => String(b.date || "").localeCompare(String(a.date || "")))}
                  columns={[
                    {
                      title: "Tarih",
                      dataIndex: "date",
                      sortable: true,
                      render: (v) => (v ? new Date(v).toLocaleDateString("tr-TR") : "-"),
                    },
                    { title: "Müşteri", dataIndex: "customer", sortable: true },
                    { title: "Proje", dataIndex: "project", sortable: true },
                    { title: "Teknisyen", dataIndex: "tech", sortable: true },
                    { title: "Seri No", dataIndex: "serial", sortable: true },
                  ]}
                  actions={[
                    {
                      label: "Görüntüle",
                      icon: FiEye,
                      onClick: (row) => row?.id && navigate(`/formlar/${row.id}`),
                    },
                  ]}
                  onRowClick={(row) => row?.id && navigate(`/formlar/${row.id}`)}
                  searchable={true}
                  pageSize={12}
                />
              </ModalBody>
            </ModalContent>
          </Modal>
        </VStack>
      </Container>
    </Box>
  );
}
